export const SECURITY_TITLE = 'Security';
export const SHARES_TITLE = 'Shares';
export const PER_SHARE_TITLE = 'Per Share Value';
export const TOTAL_VALUE_TITLE = 'Total Value';
export const SECURITY_ALIAS = 'security';
export const SHARES_ALIAS = 'shares';
export const PER_SHARE_ALIAS = 'per_share';
export const TOTAL_VALUE_ALIAS = 'value';
export const TARGET_VALUE_ALIAS = 'target_value';
